import React, { useEffect, useState } from "react";
import ViewcompanyItems from "../viewcompanies/viewcompanyItems";
import '../../css/homepage.css';

const ViewCompanies = ({ values }) => {
  const [companies, setCompanies] = useState()

  useEffect(() => {
    setCompanies(values?.companies);
  }, [])
  return (
    <div className="flex flex-col px-9">
      <div className="py-10">
        <p className="font-bold text-3xl title">View Registered companies</p>
      </div>
       <div className="grid grid-cols-12 justify-start px-5 py-4 text-[13px] text-slate-600">
        <p className="lg:col-span-2 col-span-4">Logo</p>
        <p className="lg:col-span-2 col-span-4">Name of Company</p>
        <p className="lg:col-span-2 col-span-4">Business Type</p>
      </div>
      <div className="">
        {companies?.map((item, i) => (
          <ViewcompanyItems  item={item} key={i} values={values}/>
        ))}
      </div>
    </div>
  );
};

export default ViewCompanies;
